import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import MuiSwitch from "@mui/material/Switch";

type Props = {
  checked: boolean;
  label: string;
  helperText: string;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    value: boolean
  ) => void;
};

function Switch(props: Props): JSX.Element {
  const { checked, label, helperText, onChange } = props;

  return (
    <>
      <FormControlLabel
        label={label}
        control={<MuiSwitch {...props} onChange={onChange} checked={checked} />}
      />
      {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </>
  );
}

export default Switch;
